import {LiveLog} from 'data/records/LiveLog'
import {resource, findSelector} from 'data/helpers/apiv3'

const [api, actions] = resource(LiveLog, [])

const selectors = {
  ...findSelector(LiveLog),
  byUserId: (state, userId) => state.apiv3.liveLog.id.find(s => s.userId === userId)
}

const initialState = {}
const reducers = {}

export {
  api as liveLogApi,
  actions as liveLogActions,
  selectors as liveLogSelectors,
  reducers as liveLogReducers,
  initialState as liveLogInitialState
}
